import { ColumnSortOrderEnum } from "./ExpandableTable";
export const compareSorting = (obj1, obj2, sortOrder) => {
    const value1 = extractNumericValue(obj1);
    const value2 = extractNumericValue(obj2);
    if (value1 !== null && value2 !== null) {
        return sortOrder === ColumnSortOrderEnum.Asc
            ? value1 - value2
            : value2 - value1;
    }
    const obj1AsSortableString = toComparableString(obj1);
    const obj2AsSortableString = toComparableString(obj2);
    return getSortOrder(obj1AsSortableString, obj2AsSortableString, sortOrder);
};
const toComparableString = (value) => {
    if (typeof value === "string") {
        return parseDateToSortableFormat(value);
    }
    if (value === null || value === undefined) {
        return "";
    }
    return value.toString();
};
//	Returns original value if string can't be parsed as date
const parseDateToSortableFormat = (possibleDateString) => {
    const parsedDate = parseDotSeparatedDate(possibleDateString);
    if (!parsedDate)
        return possibleDateString;
    return `${parsedDate.parts.year}-${padWithLeadingZero(parsedDate.parts.month)}-${padWithLeadingZero(parsedDate.parts.day)}`;
};
const getSortOrder = (comparingValue, currentValue, sortOrder) => {
    // Let "e" and "E" both evaluate to the same ASCII-number, and be sorted before "F" using .toLowerCase()
    const value1 = comparingValue.toLowerCase();
    const value2 = currentValue.toLowerCase();
    if (sortOrder === ColumnSortOrderEnum.Asc) {
        return boolToAscendingSortOrder(value1 < value2);
    }
    else {
        return boolToAscendingSortOrder(value1 > value2);
    }
};
//	If true, value is smaller than the compared value, and we return -1 so its sorted ascendingly
const boolToAscendingSortOrder = (booleanValue) => booleanValue ? -1 : 1;
const extractNumericValue = (value) => {
    if (value === null || value === undefined) {
        return null;
    }
    if (typeof value === "number") {
        return Number.isFinite(value) ? value : null;
    }
    if (value instanceof Date) {
        return value.getTime();
    }
    if (typeof value !== "string") {
        return null;
    }
    const trimmedValue = value.trim();
    if (!trimmedValue) {
        return null;
    }
    const parsedDate = parseDotSeparatedDate(trimmedValue);
    if (parsedDate) {
        return parsedDate.timestamp;
    }
    const normalizedValue = trimmedValue.replace(",", ".");
    const numericMatch = normalizedValue.match(/^[-+]?\d+(\.\d+)?/);
    if (!numericMatch) {
        return null;
    }
    const parsedNumber = parseFloat(numericMatch[0]);
    return Number.isNaN(parsedNumber) ? null : parsedNumber;
};
const DOT_SEPARATED_DATE_REGEX = /^\s*(\d{1,2})\.(\d{1,2})\.(\d{2,4})\s*$/;
const parseDotSeparatedDate = (value) => {
    const match = DOT_SEPARATED_DATE_REGEX.exec(value);
    if (!match) {
        return null;
    }
    const day = Number(match[1]);
    const month = Number(match[2]);
    const year = normalizeYear(match[3]);
    if (!isValidDateInput(day, month, year)) {
        return null;
    }
    const utcTimestamp = Date.UTC(year, month - 1, day);
    const utcDate = new Date(utcTimestamp);
    if (utcDate.getUTCFullYear() !== year ||
        utcDate.getUTCMonth() !== month - 1 ||
        utcDate.getUTCDate() !== day) {
        return null;
    }
    return {
        parts: { day, month, year },
        timestamp: utcTimestamp
    };
};
const normalizeYear = (rawYear) => {
    if (rawYear.length === 2) {
        return 2000 + Number(rawYear);
    }
    return Number(rawYear);
};
const isValidDateInput = (day, month, year) => Number.isInteger(day) &&
    Number.isInteger(month) &&
    Number.isInteger(year) &&
    day >= 1 &&
    day <= 31 &&
    month >= 1 &&
    month <= 12 &&
    year >= 1000 &&
    year <= 9999;
const padWithLeadingZero = (value) => value.toString().padStart(2, "0");
//# sourceMappingURL=utils.js.map